import { jsx as _jsx } from "react/jsx-runtime";
const UnderfloorHeating = () => (_jsx("svg", Object.assign({ viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "m62.08 60.33h-60.16v-56.66h60.13v4.2h-55.93v48.26h51.76v-27.27h-30.77v6.28h24.48v14.7h-39.18v-35.68h49.64v4.2h-45.44v27.28h30.78v-6.29h-24.49v-14.7h39.18z" }) })));
UnderfloorHeating.iconName = "underfloorheating";
UnderfloorHeating.iconCategory = "Misc - Deprecated";
UnderfloorHeating.deprecated = true;
export default UnderfloorHeating;
